// extracted by mini-css-extract-plugin
export default {"table":"RepoList_table__cTpJs","head":"RepoList_head__uKLUT","name":"RepoList_name__BXXuY"};